<template>
  <v-container id="page-delivery-list">
    <div class="page-title">{{ $route.name }}</div>

    <v-row justify="end" class="mr-2">
      <v-menu
          v-model="startMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <div style="width: 200px">
            <v-text-field
                v-model="startDate"
                label="시작일"
                prepend-icon="event"
                readonly
                v-on="on"
            ></v-text-field>
          </div>
        </template>
        <c-date-picker v-model="startDate" @input="startMenu = false" firstDayOfWeek="1"
                       :selectedDate="startDate" locale="ko-kr"></c-date-picker>
      </v-menu>
      <v-menu
          v-model="endMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <div style="width: 200px">
            <v-text-field
                v-model="endDate"
                label="종료일"
                prepend-icon="event"
                readonly
                v-on="on"
            ></v-text-field>
          </div>
        </template>
        <c-date-picker v-model="endDate" @input="endMenu = false" firstDayOfWeek="1"
                       :selectedDate="endDate" locale="ko-kr"></c-date-picker>
      </v-menu>
      <v-menu
          v-model="keywordMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <div style="width: 400px">
            <v-text-field
                v-model="keyword"
                label="검색어"
                placeholder="기사이름, 차량번호, 예약자"
                prepend-icon="search"
                v-on="on"
                maxlength="32"
            ></v-text-field>
          </div>
        </template>
      </v-menu>
    </v-row>
    <c-card outlined class="mb-3">
      <v-row>
        <v-col cols="12" md="12" sm="12">
          <span>배송 현황</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="2" sm="4">
          <span class="title font-weight-bold">배차 대기</span>
        </v-col>
        <v-col cols="12" md="1" sm="2">
          <span class="display-1">{{ counts.deliveryWait }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="4">
          <span class="title font-weight-bold">배송 예정</span>
        </v-col>
        <v-col cols="12" md="1" sm="2">
          <span class="display-1">{{ counts.deliverySchedule }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="4">
          <span class="title font-weight-bold">배송 완료</span>
        </v-col>
        <v-col cols="12" md="1" sm="2">
          <span class="display-1">{{ counts.deliveryDone }}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" sm="12">
          <span class="">결제 현황</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="2" sm="4">
          <span class="title font-weight-bold">결제 완료</span>
        </v-col>
        <v-col cols="12" md="1" sm="2">
          <span class="display-1">{{ counts.paid }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="4">
          <span class="title font-weight-bold">결제 미완료</span>
        </v-col>
        <v-col cols="12" md="1" sm="2">
          <div class="red--text display-1" @click="onlyUnpaid = !onlyUnpaid" v-ripple style="display:inline-block;">
            {{ counts.unpaid }}
          </div>
        </v-col>
      </v-row>
    </c-card>
    <c-table
        :headers="tableHeader"
        :items="tableData"
        item-key="id"
    >
      <template #expectedStartTime="{ item }">
        {{ item.expectedStartTime ? $func.dateTimeToString(item.expectedStartTime) : '-' }}
      </template>
      <template #realEndTime="{ item }">
        {{ item.realEndTime ? $func.dateTimeToString(item.realEndTime) : '-' }}
      </template>
      <template #addr="{ item }">
        {{ item.expectedDeparture }}<br>
        {{ item.expectedDestination }}
      </template>
      <template #expectedFee="{ item }">
        {{ Number(item.expectedFee).toLocaleString() }}
      </template>
      <template #realFee="{ item }">
        {{ Number(item.realFee).toLocaleString() }}
      </template>
      <template #payState="{ item }">
        {{ item.payState ? item.payState.configName : '' }}
      </template>
      <template #state="{ item }">
        <v-menu offset-y>
          <template v-slot:activator="{on}">
            <c-btn v-on="on" rounded :class="setChipsColor(item.state.configValue)">{{item.state.configName}}</c-btn>
          </template>
          <v-list flat v-if="deliveryStateIsWaiting(item)">
            <v-list-item active-class="border" @click="setDeliverySchedule(item)">
              <v-icon color="dark3Grey"> update</v-icon>
              <v-list-item-title class="pl-1"> 수동배차</v-list-item-title>
            </v-list-item>
          </v-list>
          <v-list flat v-else-if="deliveryStateIsDispatched(item)">
            <v-list-item
                active-class="border"
                @click="onCancelDispatch(item)"
            >
              <v-icon color="dark3Grey">update</v-icon>
              <v-list-item-title class="pl-1"> 배차 취소</v-list-item-title>
            </v-list-item>
          </v-list>
          <v-list flat v-else-if="deliveryStateIsCanceled(item)">
            <v-list-item active-class="border" @click="changeCancelType(item.id, 1)">
              <v-icon color="dark3Grey">update</v-icon>
              <v-list-item-title class="pl-1"> 무단 취소</v-list-item-title>
            </v-list-item>
          </v-list>
          <v-list flat v-else-if="deliveryStateIsUserCanceled(item)">
            <v-list-item active-class="border" @click="changeCancelType(item.id, 2)">
              <v-icon color="dark3Grey">update</v-icon>
              <v-list-item-title class="pl-1"> 정상 취소</v-list-item-title>
            </v-list-item>
          </v-list>

        </v-menu>
      </template>
      <template #detail="{ item }">
        <c-btn icon iconName="search" :to="`/delivery/${item.id}`"></c-btn>
      </template>
    </c-table>

    <manual-delivery-dialog
        :open.sync="manualDialogOpen"
        :delivery-check-data.sync="deliveryInfo"
        :deliveryFlag.sync="deliveryFlag"
    ></manual-delivery-dialog>
  </v-container>
</template>

<script>
import ManualDeliveryDialog from "@/views/CallTaxi/Delivery/ManualDeliveryDialog";
export default {
  components: {ManualDeliveryDialog},
  data() {
    return {
      startDate: this.$func.curDateStringAddDays(-7),
      endDate: this.$func.curDateString(),
      keyword: '',
      startMenu: false,
      endMenu: false,
      keywordMenu: false,
      onlyUnpaid: false,

      deliveryList: [],
      tableData: [],

      counts: {
        deliveryWait: 0,
        deliverySchedule: 0,
        deliveryDone: 0,
        paid: 0,
        unpaid: 0
      },

      manualDialogOpen: false,
      deliveryFlag: null,
      deliveryInfo: {},

      cancelDialogOpen: false,
      cancelDeliveryId: '',

      tableHeader: [
        {
          text: '번호',
          value: 'idx',
          align: 'center',
          sortable: true,
        },
        {
          text: '예약자',
          value: 'customerName',
          align: 'center',
          sortable: true,
        },
        {
          text: '예상 픽업 시간',
          value: 'expectedStartTime',
          align: 'center',
          sortable: true,
        },
        {
          text: '배송 완료 시간',
          value: 'realEndTime',
          align: 'center',
          sortable: true,
        },
        {
          text: '출발지/도착지',
          value: 'addr',
          align: 'center',
          sortable: false,
        },
        {
          text: '차량번호',
          value: 'plateNo',
          align: ' center',
          sortable: false,
        },
        {
          text: '담당기사',
          value: 'driverName',
          align: 'center',
          sortable: false,
        },
        {
          text: '진행 상황',
          value: 'state',
          align: 'center',
          sortable: false,
        },
        {
          text: '요금(원)',
          value: 'expectedFee',
          align: 'center',
          sortable: false,
        },
        {
          text: '실 결제요금(원)',
          value: 'realFee',
          align: 'center',
          sortable: false,
        },
        {
          text: '결제 상황',
          value: 'payState',
          align: 'center',
          sortable: false,
        },
        {
          text: '상세보기',
          value: 'detail',
          align: 'center',
          sortable: false
        },
      ],
    }
  },
  activated() {
    this.reqDeliveryList();
  },
  watch: {
    startDate: function () {
      this.reqDeliveryList();
    },
    endDate: function () {
      this.reqDeliveryList();
    },
    keyword: function() {
      this.filterTableData();
    },
    onlyUnpaid: function () {
      this.filterTableData();
    },
    deliveryFlag(newVal) {
      if (newVal && newVal === 'success') {
        this.rowUpdate(this.deliveryInfo);
        this.deliveryFlag = null;
      }
    },
  },
  methods: {
    async reqDeliveryList() {
      try {
        const res = await this.$api.getDeliveryListByDate(this.startDate, this.endDate);
        this.deliveryList = res.data;
        this.makeStatistics(res.data);

        this.filterTableData();
      } catch (err) {
        this.$store.commit('snackbar', {err, where:'reqDeliveryList'});
      }
    },
    setChipsColor(data) {
      if (data === 'dvry_to_be_done') {
        // 배송예정
        return 'light1Green'
      } else if (data === 'dvry_done') {
        // 배송완료
        return 'light2Blue'
      } else if (data === 'dvry_wait_assignment') {
        // 배차대기
        return 'light1Red';
      } else if (data === 'dvry_user_cancel') {
        // 무단취소
        return 'red';
      } else if (data === 'dvry_admin_cancel') {
        // 정상취소
        return 'light2Grey';
      }
    },
    setDeliverySchedule(delivery) {
      // TODO 수동배다 dialog가 꺼질때 deliveryInfo도 reset 해주어야함.
      this.deliveryInfo = delivery;
      this.manualDialogOpen = true;
    },
    onCancelDispatch(delivery) {
      this.$store.commit('alert',
          {
            open: true, persistent: true, msg: "배차 대기 상태로 변경하시겠습니까?",
            confirm: true, callBack: async () => {
              const reqDate = {
                id: delivery.id,
                deliveryState: 'dvry_wait_assignment'
              };
              await this.reqUpdateDeliveryState(reqDate);
            }
          });
    },
    makeStatistics(deliveryList) {
      this.counts = {
        deliveryWait: 0,
        deliverySchedule: 0,
        deliveryDone: 0,
        paid: 0,
        unpaid: 0
      }
      deliveryList.map(item => {
        switch (item.state.configValue) {
          case 'dvry_wait_assignment':
            this.counts.deliveryWait++;
            break;
          case 'dvry_to_be_done':
            this.counts.deliverySchedule++;
            break;
          case 'dvry_done':
            this.counts.deliveryDone++;
            break;
        }
        if (item.payState && item.payState.configValue === 'dps_done') this.counts.paid++;
        else this.counts.unpaid++;
      })
    },
    async filterTableData() {
      this.tableData = [];
      this.deliveryList.map((item, idx) => {
        if ( (item.driverName && item.driverName.indexOf(this.keyword) > -1)
            || (item.plateNo && item.plateNo.indexOf(this.keyword) > -1)
            || item.customerName.indexOf(this.keyword) > -1 ) {
          if ( !this.onlyUnpaid || (item.payState && item.payState.configValue !== 'dps_done') || !item.payState) {
            const newItem = {...item};
            newItem.idx = this.deliveryList.length - idx;
            this.tableData.push(newItem);
          }
        }
      });
    },
    async reqUpdateDeliveryState(data) {
      try {
        await this.$api.updateDeliveryState(data);
        this.reqDeliveryList();
      } catch (err) {
        this.$store.commit('snackbar', {err, where:'reqUpdateDeliveryState'});
      }
    },
    rowUpdate(data) {
      const idx = this.deliveryList.map(item => item.id).indexOf(data.id);
      this.deliveryList[idx].state = data.state;
      this.deliveryList[idx].driverName = data.driverName;
      this.deliveryList[idx].plateNo = data.plateNo;
      this.filterTableData();
    },
    deliveryStateIsWaiting(delivery) {
      return delivery.state.configValue ==='dvry_wait_assignment';
    },
    deliveryStateIsDispatched(delivery){
      return delivery.state.configValue === 'dvry_to_be_done';
    },
    deliveryStateIsCanceled(delivery) {
      return delivery.state.configValue === 'dvry_admin_cancel';
    },
    deliveryStateIsUserCanceled(delivery) {
      return delivery.state.configValue === 'dvry_user_cancel';
    },
    changeCancelType(id, type) {
      // 1: 무단취소, 2: 정상취소
      const deliveryState = (type === 1) ? 'dvry_user_cancel' : 'dvry_admin_cancel';
      const reqParam = {
        id: id,
        deliveryState: deliveryState
      };
      this.reqCancelDelivery(reqParam);
    },
    async reqCancelDelivery(data) {
      try {
        const res = await this.$api.cancelDelivery(data);
        this.rowUpdate(res.data);
      } catch (err) {
        this.$store.commit('snackbar', {err, where:'reqCancelDelivery'});
      }
    },
  },
}
</script>

<style scoped>

</style>